import React, { Component } from 'react';
import { m } from '../../utils';
import { StripeProvider } from 'react-stripe-elements';
import NegativeBalance from './NegativeBalance';
import SquareForm from './SquareForm';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';

import './payments.css';

class Summary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentModal: false,
    };
  }
  render() {
    const api_key = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    const { latestStatement, currentUser, isLatestStatement, highestPaycheck, togglePayingBalance } = this.props;
    const user = currentUser;
    return (
      <div className="payments__summary">
        <Modal open={this.state.paymentModal}>
          {user.operatingCity === "new_york" ? 
          <SquareForm 
            email={user.email}
            firstName={user.firstName}
            lastName={user.lastName}
            paymentForm={window.SqPaymentForm} 
            amount={Math.abs(latestStatement.realTimeBalance.toFixed(2))}
            onClick={() => this.setState({ paymentModal: false })}
          /> :
          <StripeProvider apiKey={api_key}>
            <NegativeBalance
              email={user.email}
              firstName={user.firstName}
              lastName={user.lastName}
              owing={false}
              amount={Math.abs(latestStatement.realTimeBalance.toFixed(2))}
              onClick={() => this.setState({ paymentModal: false })}
            />
          </StripeProvider>}
        </Modal>
        <div className="payments__summary--container">
          <div className="payments__summary--current">
            <div className="payments__summary--current-title">{isLatestStatement ? "Cumulative Balance" : "Statement Balance"}</div>
            <div
              className={`payments__summary--current-earnings ${
                isLatestStatement && latestStatement.realTimeBalance.toFixed(2) < 0 ? 'red' : latestStatement.balance.toFixed(2) < 0 ? 'red' : ''
              }`}>
              {' '}
              {isLatestStatement ? 
                `$${latestStatement.realTimeBalance.toFixed(2)}` : (currentUser.operatingCity === "toronto" ? 
                  (latestStatement.payout > 0 ? 
                    `$${latestStatement.payout.toFixed(2)}` : `$${latestStatement.balance.toFixed(2)}`) : `$${latestStatement.balance.toFixed(2)}`)}
            </div>
            {isLatestStatement ? <div className="payments__summary--current-period"></div> :
            <div className="payments__summary--current-period">{`${m(
              latestStatement.period.replace(/\s.*/, ''),
              'YYYY-MM-DD'
            ).format('MMM Do')} - ${m(latestStatement.period.replace(/\s.*/, ''), 'YYYY-MM-DD')
              .add(1, 'week')
              .format('MMM Do')}`}</div>}
          </div>
          <div className="payments__summary--right">
            {currentUser.operatingCity === "toronto" ? 
            <div className="payments__summary--best">
              <div className="payments__summary--best-title">Best Week</div>
              <div className="payments__summary--best-number">${highestPaycheck.payout}</div>
              </div> : <div className="payments__summary--best"></div>}
            {latestStatement.realTimeBalance < 0 && isLatestStatement ? (
              <Button
                className="payments__summary--button"
                primary
                label="Pay Balance"
                onClick={togglePayingBalance}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

export default Summary;



// WEBPACK FOOTER //
// ./src/components/NewPayments/Summary.js